import { motion } from "framer-motion";
import { SectionHead, EASE } from "./motion";

const STEPS = [
  ["Reach out", "Call, text or send a quote request with your vehicle and the work you want."],
  ["Get your quote", "We confirm pricing based on vehicle size, condition and requested work."],
  ["Shop or mobile", "Drop it at 1909 43 Street, book pickup, or we come to you with water and power."],
  ["Drive away glossy", "Pick up a finish that looks better than the day it left the lot."],
];

export const Process = () => (
  <section id="process" data-testid="process-section" className="relative bg-[#0b0d12] border-y border-white/10 py-24 md:py-36 overflow-hidden">
    <div className="mx-auto max-w-[1440px] px-5 md:px-10">
      <SectionHead eyebrow="04 — How it works" lines={["Four steps", "to the gloss."]} />
      <div className="mt-16 md:mt-24 grid md:grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 border border-white/10">
        {STEPS.map(([t, d], i) => (
          <motion.div key={t} data-testid={`process-step-${i + 1}`}
            initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 0.9, ease: EASE, delay: i * 0.1 }}
            className="group relative bg-[#0b0d12] p-8 md:p-10 min-h-[300px] flex flex-col justify-between hover:bg-[#10141c] transition-colors">
            <span className="font-display font-black text-7xl md:text-8xl outline-text group-hover:[-webkit-text-stroke:1px_#1bb4f2] transition-colors">0{i + 1}</span>
            <div>
              <h3 className="font-display font-extrabold uppercase text-xl md:text-2xl">{t}</h3>
              <p className="mt-3 text-sm text-slate-300 leading-relaxed">{d}</p>
            </div>
            <span className="absolute bottom-0 left-0 h-[2px] w-full bg-[#1bb4f2] origin-left scale-x-0 group-hover:scale-x-100 transition-transform duration-700" />
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
